// -----------------------------------------------------------------------------
export interface OWListenerDelegate {
}

// -----------------------------------------------------------------------------
// The reason for this pattern is to make sure developers remember to call
// |removeListener| before |addListener| and also allow them an easy means of
// turning listeners on and off.
export abstract class OWListener<T extends OWListenerDelegate> {
  protected _delegate: T;

  // ---------------------------------------------------------------------------
  constructor(delegate: T) {
    this._delegate = delegate;
  }

  // ---------------------------------------------------------------------------
  public start(): void {
    // It is a best-practice to call |removeListener| before |addListener|
    this.stop();
  }

  // ---------------------------------------------------------------------------
  abstract stop(): void;
}
